import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
import { useStore } from '../context/StoreContext';
import { ProductCard } from '../components/ProductCard';
export function WishlistPage() {
  const {
    products,
    wishlist
  } = useStore();
  const wishlistedProducts = products.filter(p => wishlist.includes(p.id));
  if (wishlistedProducts.length === 0) {
    return <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center px-4 py-20" data-id="element-1401">
        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} data-id="element-1402">
          <div className="w-24 h-24 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1403">
            <HeartIcon className="w-10 h-10 text-red-300" data-id="element-1404" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-1405">
            Your Wishlist is Empty
          </h2>
          <p className="text-slate-500 mb-8 max-w-md" data-id="element-1406">
            Save items you love to your wishlist and come back to them anytime.
          </p>
          <Link to="/products" className="inline-flex items-center gap-2 px-8 py-3 bg-sky-600 text-white font-semibold rounded-lg hover:bg-sky-700 transition-colors" data-id="element-1407">
            Browse Products
          </Link>
        </motion.div>
      </div>;
  }
  return <div className="min-h-screen bg-slate-50" data-id="element-1408">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8" data-id="element-1409">
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2" data-id="element-1410">
          My Wishlist
        </h1>
        <p className="text-slate-500 mb-8" data-id="element-1411">
          {wishlistedProducts.length} item
          {wishlistedProducts.length !== 1 ? 's' : ''} saved
        </p>
        <motion.div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" initial="hidden" animate="visible" variants={{
        visible: {
          transition: {
            staggerChildren: 0.05
          }
        }
      }} data-id="element-1412">
          {wishlistedProducts.map(product => <motion.div key={product.id} variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0
          }
        }} data-id="element-1413">
              <ProductCard product={product} data-id="element-1414" />
            </motion.div>)}
        </motion.div>
      </div>
    </div>;
}